import { cn } from "@/lib/utils";

/** Prose classes matching Information question rich-text display. */
export const RICH_TEXT_HTML_PROSE_CLASS =
  "prose prose-sm max-w-none [&>ul]:list-disc [&>ul]:ml-4 [&>ol]:list-decimal [&>ol]:ml-4 [&>p]:mb-4 [&>p:last-child]:mb-0 [&>h1]:text-lg [&>h1]:font-bold [&>h1]:mb-4 [&>h2]:text-base [&>h2]:font-bold [&>h2]:mb-3 [&>blockquote]:border-l-4 [&>blockquote]:border-muted-foreground/20 [&>blockquote]:pl-4 [&>blockquote]:italic";

/**
 * Renders HTML from the authoring RichTextEditor.
 * Same trust model as Information questions: content is operator-authored, not sanitized.
 */
export function RichTextHtml({
  html,
  className,
}: {
  html: string;
  className?: string;
}) {
  return (
    <div
      data-rich-text-html
      className={cn(RICH_TEXT_HTML_PROSE_CLASS, className)}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: Content comes from trusted rich text editor
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
